module.exports = __webpack_public_path__ + "img/4.eb6d1a8.png";